import { z } from 'zod'

export const COACHING_SHELL_RESOURCE_CONTRACT_VERSION = '1.0.0' as const
export const coachingShellResourceResponseSchema = z.unknown()
export type CoachingShellResourceResponse = z.infer<typeof coachingShellResourceResponseSchema>
